/**
 * Persistenza in sessionStorage di metadati della chiamata SIP in corso.
 * Serve a offrire un banner di "recovery" post-refresh (vedi SipCallRecoveryBanner.vue).
 * Non persiste la sessione media: WebRTC non sopravvive al refresh del documento.
 */

export const CALL_RECOVERY_STORAGE_KEY = "sip:active-call-snapshot";
export const CALL_RECOVERY_MAX_AGE_MS = 120_000; // 2 minuti

export interface CallRecoverySnapshot {
  phoneNumber: string;
  callDirection: "incoming" | "outgoing";
  callStartTime: number;
  targetUrl: string | null;
  savedAt: number;
}

export type CallRecoveryInput = Omit<CallRecoverySnapshot, "savedAt">;

export function saveSnapshot(input: CallRecoveryInput): void {
  if (!input.phoneNumber) {
    throw new Error("saveSnapshot: phoneNumber is required");
  }

  const payload: CallRecoverySnapshot = { ...input, savedAt: Date.now() };
  sessionStorage.setItem(CALL_RECOVERY_STORAGE_KEY, JSON.stringify(payload));
}

export function loadSnapshot(): CallRecoverySnapshot | null {
  const raw = sessionStorage.getItem(CALL_RECOVERY_STORAGE_KEY);
  if (!raw) return null;

  let parsed: CallRecoverySnapshot;
  try {
    parsed = JSON.parse(raw) as CallRecoverySnapshot;
  } catch {
    clearSnapshot();
    return null;
  }

  if (Date.now() - parsed.savedAt > CALL_RECOVERY_MAX_AGE_MS) {
    clearSnapshot();
    return null;
  }

  return parsed;
}

export function clearSnapshot(): void {
  sessionStorage.removeItem(CALL_RECOVERY_STORAGE_KEY);
}
